import { useContext, useEffect, useRef, useState } from "react";
import { GridLayout, HorizontalLayout, HorizontalPageLayout, VerticalLayout, VerticalPageLayout } from "../components/layout";
import { ProjectComp } from "../components/ProjectComp";
import { TitleAction } from "../molecule/TitleAction";
import { Alert } from "../components/alert";
import { deleteAPI, fetchAPI, getAPI, postAPI } from "../api/api";
import { CreateProjectModal, FaseModal } from "../components/customModals";
import { DropdownButton, IconButton, StandardButton } from "../atoms/buttons";
import { CourseComp, IconText } from "../components/courseComp";
import { StandardComp } from "../atoms/standardComp";
import { PageContext, UserContext } from "../App";
import { TitleDescriptionText } from "../atoms/titleDescription";
import { TextAtom } from "../atoms/TextAtom";
import { EmailLeads, Social } from "../components/publishActionComp";
import DepartmentSelectors from "../molecule/departmentSelector";
import { LayoutButton } from "../atoms/presentation";
import { CourseTableComp, CourseTableRow, SimpleCourseTableRow } from "../components/courseTableComp";
import { SkeletonCourseTableRow } from "../atoms/skeletonloaders";
import { NavItem } from "../atoms/navItem";
import { margin } from "polished";
import { icon } from "../functions/icons";

export function Project({ pageSwap }) {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedProjectDetail, setSelectedProjectDetail] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showFaseModal, setFaseModal] = useState(false);
  const [activeModal, setActiveModal] = useState("");
  const [activeTitle, setActiveTitle] = useState("");
  const [stepId, setStepId] = useState(null);
  const [pageType, setPageType] = useState("Workflow");
  const userInformation = useContext(UserContext);
  const isPublic = userInformation.account_type === 1;
  const [dates, setDates] = useState({ start: null, end: null });
  const [presentationStyle, setPresentationStyle] = useState(2);

  
  const LoadProject = async () => {
    setLoading(true);
    const query = "api/workflows";
    const res = await fetchAPI(query);
    setProjects(Array.isArray(res) ? res : []);
    setLoading(false);
    return res;
  };

  const loadProjectDetail = async (id_project) => {
    const query = `api/workflows/${id_project}`;
    const res = await fetchAPI(query);
    setSelectedProjectDetail(res);
  };

  const removeCourse = async (selectedCourse, stepId) => {
    const query = `api/workflows/remove-course`;
    const body = {
        id_step: stepId,
        id_course: selectedCourse
      };
    const res = await deleteAPI(query, body);
        if (res.status === "ok") {
          setFaseModal(false);
          await loadProjectDetail(selectedProjectDetail[0].id_workflow);
        }
    };

  const createWorkflow = async ({ project_name, description, status }) => {
    const body = { project_name, description, status };
    const query = `api/workflows/create`;
    const res = await postAPI(query, body);
      if (res.status === "ok") {
        await LoadProject();
      }
  };

  const handleTitleUpdate = async (newTitle) => {
    const workflowId = selectedProjectDetail?.[0].id_workflow
    const body = { workflowId, newTitle }
    const query = `api/workflows/update-name`;
    const res = await postAPI(query, body);
    if (res.status === "ok") {
            LoadProject();
      await loadProjectDetail(workflowId);
    }
  };

  useEffect(() => {
    LoadProject();
  }, []);
  const backUpName = isPublic ? "Campagnes" : "Workflows"
  const projectName = selectedProjectDetail?.[0]?.projectName || backUpName;

  const today = new Date().toISOString().split("T")[0];

  const handleWorkflowRemoved = async () => {
        setSelectedProjectDetail(null);
        await LoadProject()
  }

  const formatDisplayDate = (isoDate) => {
    if (!isoDate) return "";
    const [y, m, d] = isoDate.split("-");
    return `${d}-${m}-${y}`;
  };
  const handleEdit = () => {
    if (selectedProjectDetail === null) {
        return false;
    }
    return true;
  }

  return (
    <>
      <VerticalPageLayout
        className={`project-page page-in-animation ${pageSwap ? "page-out-animation" : ""}`}
        style={{ alignItems: "unset", overflowX: "hidden" }}
      >
        <TitleAction
          goBack={selectedProjectDetail ? () => { setSelectedProjectDetail(null); LoadProject(); } : undefined}
          onClick={selectedProjectDetail
                  ? () => {
                      setActiveModal("delete");
                      setFaseModal(true);
                      setActiveTitle(`${isPublic ? "Campagne" : "Workflow"} verwijderen`);
                    }
                  : () => {
                      setShowCreateModal(true);
                      setActiveTitle(`Stel je ${isPublic ? "campagne" : "workflow"} samen`);
                    }}
          title={projectName}
          buttonTitle={selectedProjectDetail ? `${isPublic ? "Campagne" : "Workflow"} verwijderen` : `Stel je ${isPublic ? "campagne" : "workflow"} aan`}
          editable={handleEdit}
          onRename={handleTitleUpdate}
        />

        {projects.length === 0 && !loading && (
          <Alert
            className="standard-margin"
            type="warning"
            title="Geen projecten"
            message="Er zijn nog geen projecten beschikbaar. Gebruik de knop '+ project' om een nieuw project aan te maken."
          />
        )}

        {!selectedProjectDetail && (
          <ProjectComp
            projects={projects}
            onSelectProject={loadProjectDetail}
          />
        )}

        {selectedProjectDetail && isPublic ? (
          <Campaign
            selectedProjectDetail={selectedProjectDetail}
            setFaseModal={setFaseModal}
            setActiveModal={setActiveModal}
            setstepId={setStepId}
            removeCourse={removeCourse}
            formatDisplayDate={formatDisplayDate}
            pageType={pageType}
            today={today}
            setdates={setDates}
            setPresentationStyle={setPresentationStyle}
          />
        ) : (          
           <Workflows
            selectedProjectDetail={selectedProjectDetail}
            setFaseModal={setFaseModal}
            setActiveModal={setActiveModal}
            setstepId={setStepId}
            removeCourse={removeCourse}
            formatDisplayDate={formatDisplayDate}
            pageType={pageType}
            today={today}
            setdates={setDates}
          /> )}

        <CreateProjectModal
          visible={showCreateModal}
          dismiss={() => setShowCreateModal(false)}
          position="center"
          createWorkflow={createWorkflow}
        />
      </VerticalPageLayout>

      {showFaseModal && selectedProjectDetail && (
        <FaseModal
          visible={showFaseModal}
          type={activeModal}
          title={activeTitle}
          project={selectedProjectDetail}
          dateRanges={dates}
          dismiss={() => setFaseModal(false)}
          onWorkflowRemoved={handleWorkflowRemoved}
          onCourseAdded={() => loadProjectDetail(selectedProjectDetail[0].id_workflow)}
          onDateRangeChange={() => loadProjectDetail(selectedProjectDetail[0].id_workflow)}
          stepId={stepId}
        />
      )}
    </>
  );
}

const Workflows = ({ selectedProjectDetail, setActiveModal, setFaseModal, pageType, removeCourse, formatDisplayDate, setstepId, setdates }) => {
  const navigationContext = useContext(PageContext);
  const steps = selectedProjectDetail?.steps || selectedProjectDetail || [];
  
  const handleDateUpdate = (step) => {
  setActiveModal("dateRange");
  setFaseModal(true);
  setdates({ start: step.start_date, end: step.end_date });
  setstepId(step.id_step);
  };

  const handleAddButton = (step) => {
    setstepId(step.id_step);
    setActiveModal("courses");
    setFaseModal(true);
  };
  
  return (  
    <>
    {steps.some((step) => step.courses?.length > 0) && (
      steps.map((step) => (
        <StandardComp
          style={{ marginLeft: "1.5rem"}}
          editClass={"standard-margin-bottom standard-shadow"}
          key={step.id_step}
          content={
            <>              
              <StepHeader setActiveModal={setActiveModal} setFaseModal={setFaseModal} formatDisplayDate={formatDisplayDate} step={step} setStepId={setstepId} handleDateUpdate={handleDateUpdate} />
                <CourseLayout>
                <CourseCards courses={step.courses} pageType={pageType} onRemoveCourse={removeCourse} stepId={step.id_step} navigationContext={navigationContext} />
                <AddButton onClick={() => handleAddButton(step)} />
              </CourseLayout>
            </>
          }
        />
    )))}
      { selectedProjectDetail && <AddStepCard onClick={() => { setActiveModal("addStep"); setFaseModal(true)}} />} 
      </>
  );
};

const Campaign = ({ selectedProjectDetail, setActiveModal, setFaseModal, pageType, removeCourse, formatDisplayDate, setstepId, setdates, setPresentationStyle, isActive }) => {
  const navigationContext = useContext(PageContext);
  const steps = selectedProjectDetail?.steps || selectedProjectDetail || [];
  const [activeCourse, setActiveStep] = useState(null);

  
  const handleDateUpdate = (step) => {
  setActiveModal("dateRange");
  setFaseModal(true);
  setdates({ start: step.start_date, end: step.end_date });
  setstepId(step.id_step);
  };

  const handleAddButton = (step) => {
    setstepId(step.id_step);
    setActiveModal("courses");
    setFaseModal(true);
  };
  
  return (  
    <>
    {steps.some((step) => step.courses?.length > 0) && (
      steps.map((step) => (
        <>
        <StandardComp
          style={{ minHeight: "40rem", maxHeight: "40rem",position: "relative", width: "auto",margin: "0 1.5rem", boxSizing: "border-box", padding: "1.5rem 0 1.5rem 1.5rem", marginBottom: "1.5rem"}}
          editClass={"standard-shadow horizontal standard-margin"}
          key={step.id_step}
          content={
            <> 
            <VerticalLayout className="campaign-content" style={{width: "100%", paddingRight: "0.5rem"}}>
            <CampaignHeader setActiveModal={setActiveModal} setFaseModal={setFaseModal} formatDisplayDate={formatDisplayDate} step={step} setStepId={setstepId} handleDateUpdate={handleDateUpdate} />
            <GridLayout className="small-standard-padding no-padding-top" gap="0.75rem" columnsTemplate={"1fr 1fr 1fr 1fr"} style={{ overflowY: "auto", maxHeight: "calc(8 * 3.9rem)"}}>
              {step.courses.map((course) => (
              <CampagneCards course={course} pageType={pageType} onRemoveCourse={removeCourse} stepId={step.id_step}  onSelectCourse={() => setActiveStep(course)}/>              
            ))}
            </GridLayout>

            </VerticalLayout>
            <CampaignSwitch data={519} />


            </>
          }
        />
        </>
    )))}
      { selectedProjectDetail && <AddCampagne onClick={() => { setActiveModal("addStep"); setFaseModal(true)}} /> }
    </>
  );
};

const CourseCards = ({ courses = [], navigationContext, pageType, onRemoveCourse, stepId}) => {
  return courses
    .filter((course) => course && course.id_course != null)
    .map((course) => {

      return (
        <CourseComp
          key={course.id_course}
          pageType={pageType}
          removeCourseId={course.id_course}
          onRemoveCourse={onRemoveCourse}
          stepId={stepId}
          costumColumnsTemplate="0.2fr 1fr auto auto"
          style={{ gridTemplateColumns: "repeat(3, 1fr)"}}
          onClick={() =>
            navigationContext.handleNavigation({
              courseID: course.id_course,
              navigation: 7,
              enrollment: 0,
            })
          }
          title={course.title || "Untitled Course"}
          duration={course.duration || "0m"}
          lessons={course.lessonCount || 0}
          image={course.image_url || ""}
          AI={course.ai_mode === 1}
          error={course.ai_mode === 4}
        />
      );
    });    
  };

  const CampagneCards = ({ course, onRemoveCourse, stepId}) => {

       return (
        <CourseComp
          key={course.id_course}
          removeCourseId={course.id_course}
          onRemoveCourse={onRemoveCourse}
          stepId={stepId}
          title={course.title || "Untitled Course"}
          duration={course.duration || "0m"}
          lessons={course.lessonCount || 0}
          image={course.image_url || ""}
          AI={course.ai_mode === 1}
          error={course.ai_mode === 4}
        />
        
      );
       
  }

const AddButton = ({ onClick, style, size = 50 }) => {
    return (
      <div className="workflow-add-btn" onClick={onClick} style={style}>
        <IconButton
          style={{
            color: "var(--primary-500)",
            backgroundColor: "transparent",
          }}
          color="icon-spin"
          icon2="plus"
          size={size}
        />
      </div>
    );
  };

const DeleteButton = ({ onClick , style }) => {
    return (
      <div style={style} onClick={onClick}>
        <IconText
          style={{
            color: "var(--primary-500)",
            backgroundColor: "transparent",
          }}
          backgroundColor="var(--error-100)"
          iconColor={"var(--error-600)"}
          tooltipBackground={"var(--error-600)"}
          label={""}
          tooltip={"Verwijderen"}
          icon2={"trash"}
          size={50}
          color={"icon-spin"}
          tooltipLocation={"center"}
          marginBottom={"0.7rem"}
        />
      </div>
    );
  };
  
const AddStepCard = ({ onClick }) => {
    return(
       <div
        onClick={onClick}
        className = "workflow-add-btn"
        style={{
          margin: "1.5rem",
          minHeight: "2.5rem",
          width: "auto",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          gap: "0.75rem",
          color: "var(--primary-500)",
        }}
      >
        <IconButton
          color="icon-spin"
          icon2="plus"
          size={30}
          style={{
            color: "var(--primary-500)",
          }}
        />
        <TextAtom title= "Een nieuwe stap aanmaken"/>
      </div>
    )
     
  };

const AddCampagne = ({ onClick }) => {
    return(
       <div
        onClick={onClick}
        className = "workflow-add-btn"
        style={{
          margin: "1.5rem",
          minHeight: "2.5rem",
          width: "auto",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          gap: "0.75rem",
          color: "var(--primary-500)",
        }}
      >
        <IconButton
          color="icon-spin"
          icon2="plus"
          size={30}
          style={{
            color: "var(--primary-500)",
          }}
        />
        <TextAtom title= "Een nieuwe campagne stap aanmaken"/>
      </div>
    )
     
  };

const StepHeader = ({ setActiveModal, setFaseModal, formatDisplayDate, step, today, setStepId, handleDateUpdate}) => {  
    return (
      <HorizontalLayout className="space-between">
        <DeleteButton onClick={() => { setStepId(step.id_step); setActiveModal("deleteStep"); setFaseModal(true);}} />
        <TitleDescriptionText
          className="space-between horizontal"
          style={{ marginTop: "0", marginBottom: "0", paddingTop: "0", paddingLeft: "0.5rem"}}
          title={`${formatDisplayDate(step.start_date ?? today )} → ${formatDisplayDate(step.end_date ?? today)}`}
          description={`${step.courses?.filter?.(c => c)?.length || 0} cursussen`}
          editable={true}
          onClick={() => handleDateUpdate(step)}
        />
      </HorizontalLayout>
    )
  };

const CourseLayout = ({ children, gridTemplate }) => {
    return (
      <GridLayout
        className="course-grid"
        style={{ marginTop: "0", marginBottom: "0", paddingTop: "0" }}
        gap="16px"
        columnsTemplate= {gridTemplate || "repeat(4, 1fr)"}
      >
        {children}
      </GridLayout>                
    )
  };

const CampaignHeader = ({ setActiveModal, setFaseModal, formatDisplayDate, step, today, setStepId, handleDateUpdate}) => {  
    return (
      // <div class="horizontal publish-nav" style={{width: "100%", paddingTop: "0.5rem"}}>
      <HorizontalLayout className="space-between" style={{width: "40%"}}>
        <DeleteButton onClick={() => { setStepId(step.id_step); setActiveModal("deleteStep"); setFaseModal(true);}} />
        <TitleDescriptionText
          className="space-between horizontal"
          style={{ marginLeft: "0.5rem", marginTop: "0", marginBottom: "0", paddingTop: "0", paddingLeft: "0.5rem"}}
          title={`${formatDisplayDate(step.start_date ?? today )}`}
          editable={true}
          onClick={() => handleDateUpdate(step)}
        />
      </HorizontalLayout>
      // </div>
    )
  };

const CourseListView = ({ courses = [], index, courseOpen, loading = false, margin, headers= ["Cursus"], children }) => {
    
    return (
        <div class="publish-nav" style={{width: "100%", paddingTop: "1rem", borderRadius: "calc(0.625rem  * var(--br-scale))", boxShadow: "0 4px 10px rgba(0,0,0,0.15)"}}>
        {children}
        <div role="course-table" className="courses-table standard-small-margin-top standard-rounded" style={{ textAlign: "left", borderCollapse: 'collapse', margin:margin, minHeight: "30rem" }}>
            <div className="courses-table-body">
                { loading ? <>
                    { [...Array(3)].map((_, idx) => {
                        return (
                            <SkeletonCourseTableRow key={idx}/>
                        )
                    })}
                </> :
                <>   
                <div style={{ 
                height: "30rem",
                overflow: "hidden auto",
                padding: "0.5rem",
                width: "unset",
                marginRight: "1rem",
                borderRadius: "0.3rem",}}>
                    { courses.map((course) => {
                        return (
                            <SimpleCourseTableRow key={course.id_course} onClick={courseOpen} course={course} buttonVisible={true} style={{gridTemplateColumns: "1fr auto", marginBottom: index === courses.length - 1 ? "unset" : "1rem" }}/>
                        )
                    })}
                  </div>
                <AddButton style = {{width: "auto" , minHeight: "unset", height: "3rem", margin: "1rem"}} size={30} />
                </>
                }
            </div>
        </div>
        </div>
    )
}

const CampaignSwitch = ({data}) => {
  const [activeScreen, setActiveScreen] = useState()
  const [isSwitchActive, setSwitchActive] = useState(false)
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);


useEffect(() => {
    if (isSwitchActive) {
      setIsVisible(true);
      setTimeout(() => setIsAnimating(true), 10);
    } else {
      setIsAnimating(false);
      const timeout = setTimeout(() => setIsVisible(false), 140);
      return () => clearTimeout(timeout);
    }
  }, [isSwitchActive]);

  const handleExit = () => {
    return (setSwitchActive(!isSwitchActive))
  }

  const NavigationActions = ({ actions }) => {
    
      switch (actions) {
          case 1: return <Social data={data} />
          case 2: return <EmailLeads />
          case 3: return <DepartmentSelectors />
          default: return                
      }
  }
  

    const PublishNavigation = ({ activeScreen, onClick }) => {
        const navigation = [
            {
                "id": 1,
                "icon": "share"
            },
            {
                "id": 2,
                "icon": "mail"
            },
            {
                "id": 3,
                "icon": "department"
            }
        ]
        return (
            <VerticalLayout className="publish-nav" style = {{boxShadow: "rgba(0, 0, 0, 0.25) -1px 0px 4px",borderRadius: "0 calc(.8rem * var(--br-scale)) calc(.8rem * var(--br-scale)) 0", minHeight: "inherit", height: "calc(100% + 3rem)", minWidth : "3.8rem"}}>
                {navigation.map((nav) => {
                    return (
                        <NavItem
                            style={{ width: "unset", justifyContent: "center", alignItems: "center", paddingLeft: "0.5rem" }}
                            onClick={() => onClick(nav.id)}
                            icon2={nav.icon}
                            active={nav.id === activeScreen}
                        />  
                    )
                }
                )
                }
              <IconButton onClick={handleExit} className={`${isSwitchActive ? "open" : ""}  standard-margin-bottom`} size={25} icon2={isSwitchActive ? "chevron-right" : "chevron-left"} style={{pointerEvents: activeScreen ? "auto" : "none", margin: "unset", color: "var(--white)"}}  />
            </VerticalLayout>
    
        )
    }
    return (
        <>
        {isVisible && (<div class={`campagne-switch ${isAnimating ? "active" : ""}`} > <NavigationActions actions={activeScreen}/> </div>)}
        <PublishNavigation activeScreen={activeScreen} onClick={(id) => {setActiveScreen(id); setSwitchActive(true);}}/>
        </>
    )
}
